<div class="form-group ipad-md-mb-0" id="search-person-add">
  <ng-select2 [options]="options" width="100%" id="search-people" class="custom-select-field">
  </ng-select2>
</div>
